module.exports = __webpack_public_path__ + "static/media/25.662bf159.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/25.png
// module id = 807
// module chunks = 0